import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { Installment } from '../../../models/installment.model';
import { ErrorResponse } from '../../../models/error.model';
import { ServicesPaymentDialogComponent } from '../../../dialogs/services-payment-dialog/services-payment-dialog.component';
import { DocumentType } from 'src/app/models/document.model';
import { ID } from '../../../models/ID.model';
import { GuarantiesService } from '../../../services/guaranties.service';
import { DocumentsService } from '../../../services/documents.service';
import { UtilsService } from '../../../services/utils.service';
import { ActivatedRoute } from '@angular/router';
import { Warranty } from 'src/app/models/warranty.model';

@Component({
    selector: 'app-rental-administration',
    templateUrl: './rental-administration.component.html',
    styleUrls: ['./rental-administration.component.scss']
})
export class RentalAdministrationComponent implements OnInit {

    warranty?: Warranty;
    installments?: Installment[];

    paymentHistorySections = [
      { title: 'Pago de alquileres', documentType: 'COMPROBANTE_PAGO_ALQUILER' },
      { title: 'Pago de expensas', documentType: 'COMPROBANTE_PAGO_EXPENSAS' },
    ];

    constructor(
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private documentsService: DocumentsService,
        private guarantiesService: GuarantiesService,
        public utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getWarranty(params.id);
            }
        });
    }

    getWarranty(id: ID) {
        this.guarantiesService.getWarrantyById(id).subscribe(warranty => {
            this.warranty = warranty;
            if (warranty.estado === 'ACTIVA') {
                this.getInstallments();
            }
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos de la garantía', error.error?.descripcion));
    }

    getInstallments() {
        this.guarantiesService.getInstallments(this.warranty?.id).subscribe(installments => {
            this.installments = installments;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener datos de la garantía', error.error?.descripcion));
    }

    downloadDocument(documentId: ID) {
      this.documentsService.downloadDocument(documentId).subscribe(awsRequest => {
        this.utilsService.downloadFile(awsRequest);
      }, (error: ErrorResponse) => this.utilsService.alert('Error al descargar archivo', error.error?.descripcion));
    }

    findDocument(installment: Installment, documentType: DocumentType) {
      return installment?.comprobantes?.find(doc => doc.tipo === documentType);
    }

    getStatus(installment: Installment, documentType: DocumentType) {
        if (documentType === 'COMPROBANTE_PAGO_SERVICIOS') {
          let status = 'PAGADO';
          this.warranty.cotizacion.servicios.forEach(service => {
            const comprobante = installment.comprobantes.find(c => c.tipo === 'COMPROBANTE_PAGO_SERVICIOS' && c.categoria === String(service.id));
            if (!comprobante) {
              status = 'PENDIENTE';
            }
          });
          return status;
        } else {
          return this.findDocument(installment, documentType) ? 'PAGADO' : 'PENDIENTE';
        }
    }

    openServicesPaymentDialog(installment: Installment) {
      this.dialog.open(ServicesPaymentDialogComponent, { data: { installment, warranty: this.warranty } });
    }

}
